import React, { memo } from 'react'
import { designTokens } from '@/utils/design-tokens'

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  color?: 'success' | 'info' | 'warning' | 'error' | 'gray' | 'purple'
  children?: React.ReactNode
}

const Tag: React.FC<TagProps> = memo(({
  size = 'medium',
  color = 'success',
  children = '태그',
  className = '',
  ...props
}) => {
  const sizeClasses = {
    xsmall: 'px-1.5 py-1 gap-0.5 text-xs font-semibold',
    small: 'px-1.5 py-1 gap-0.5 text-sm font-semibold',
    medium: 'px-1.5 py-1 gap-0.5 text-base font-semibold',
    large: 'px-1.5 py-1 gap-0.5 text-lg font-semibold'
  }

  const colorStyles = {
    success: {
      backgroundColor: designTokens.colors.success.light,
      color: designTokens.colors.success.DEFAULT
    },
    info: {
      backgroundColor: designTokens.colors.info.light,
      color: designTokens.colors.info.DEFAULT
    },
    warning: {
      backgroundColor: designTokens.colors.warning.light,
      color: designTokens.colors.warning.DEFAULT
    },
    error: {
      backgroundColor: designTokens.colors.error.light,
      color: designTokens.colors.error.DEFAULT
    },
    gray: {
      backgroundColor: designTokens.colors.gray[1],
      color: designTokens.colors.gray[4]
    },
    purple: {
      backgroundColor: designTokens.colors.purpleLight,
      color: designTokens.colors.purple
    }
  }

  return (
    <span
      className={`
        inline-flex items-center rounded
        ${sizeClasses[size]}
        ${className}
      `}
      style={{
        ...colorStyles[color],
        fontFamily: designTokens.typography.fontFamily.sans[0],
        ...props.style
      }}
      {...props}
    >
      <span>{children}</span>
    </span>
  )
})

Tag.displayName = 'Tag'

export default Tag